import { useEffect } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { Option } from '@code/innovance-react-ui-kit';
import { IdentityFormData } from './IdentityFormData';

const useDefaultIssueCountry = (
  formMethods: UseFormMethods<IdentityFormData>,
  countries: Option[],
  countryCode?: string
): void => {
  const { watch, setValue } = formMethods;
  const code = countryCode ?? 'RU';
  useEffect(() => {
    if (!watch('issueCountry') && countries?.length) {
      setValue(
        'issueCountry',
        countries.find((c) => c.value === code)
      );
    }
  }, [watch, setValue, countries, code]);
};

export default useDefaultIssueCountry;
